import { AuthFetch, PagedList } from '../gs-core/common';

import { FilterParams, TitleStat } from '../common/models';

export class TitleService {
  constructor(private authFetch: AuthFetch) { }

  async find(filter: FilterParams): Promise<PagedList<TitleStat>> {
    const queryString = filter.toQueryString();

    return await this.authFetch(`/api/title?${queryString}`) as PagedList<TitleStat>;
  }
}



// WEBPACK FOOTER //
// ./src/services/TitleService.ts